/** Drag item types on the work plan board. */
import { Product } from "../../../../services/products-api";
import { ManufacturingOrder } from "../utils/calculations";

export const PLAN_DND = {
	/** A product (or activity) chip from the shelf. */
	PRODUCT: "plan-product",
	/** An order card already on the board. */
	ORDER: "plan-order",
} as const;

export interface ProductDragItem {
	product: Product;
}

export interface OrderDragItem {
	order: ManufacturingOrder;
}
